import ipxRuntime_363tyKZHfgswhKhXN4Ei1zxZ7Q_45MJH58wto_gc0tSrM3M from '/var/www/html/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  screens: {"sm":400,"md":640,"lg":800,"xl":1024,"2xl":1536,"xs":320,"xxl":1280},
  presets: {},
  domains: ["assets.mealzusa.com","fls-a293544e-2738-4ab0-b636-dba45820dfb2.laravel.cloud","assets.qa.mealzusa.com","assets.qa.mealzconcepts.com"],
  alias: {},
  densities: [1,2],
  format: ["webp"],
  quality: 80,
  /** @type {"ipx"} */
  provider: "ipx",
  providers: {
      ['ipx']: { setup: ipxRuntime_363tyKZHfgswhKhXN4Ei1zxZ7Q_45MJH58wto_gc0tSrM3M, defaults: {} }
  }
}
